import Vue from 'vue';
import VueI18n from 'vue-i18n';
import StripeJS from '@/plugins/StripeJS';
import ComplyAPI from '@/plugins/ComplyAPI';
// @ts-ignore
import VueDateFns from 'vue-date-fns';
import Cookie from 'js-cookie';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
// @ts-ignore
import Va from 'vue-atlas';
import 'vue-atlas/dist/vue-atlas.css';

import App from './App.vue';
import './App.scss';

import { store } from './store';
import router from './router';

import '@/assets/css/tailwind.css';

// @ts-ignore
import bg from '@/locales/bg.json';
// @ts-ignore
import cs from '@/locales/cs.json';
// @ts-ignore
import da from '@/locales/da.json';
// @ts-ignore
import de from '@/locales/de.json';
// @ts-ignore
import el from '@/locales/el.json';
// @ts-ignore
import en from '@/locales/en.json';
// @ts-ignore
import es from '@/locales/es.json';
// @ts-ignore
import et from '@/locales/et.json';
// @ts-ignore
import fi from '@/locales/fi.json';
// @ts-ignore
import fr from '@/locales/fr.json';
// @ts-ignore
import ga from '@/locales/ga.json';
// @ts-ignore
import he from '@/locales/he.json';
// @ts-ignore
import hr from '@/locales/hr.json';
// @ts-ignore
import hu from '@/locales/hu.json';
// @ts-ignore
import it from '@/locales/it.json';
// @ts-ignore
import ja from '@/locales/ja.json';
// @ts-ignore
import lt from '@/locales/lt.json';
// @ts-ignore
import lv from '@/locales/lv.json';
// @ts-ignore
import mt from '@/locales/mt.json';
// @ts-ignore
import nl from '@/locales/nl.json';
// @ts-ignore
import pl from '@/locales/pl.json';
// @ts-ignore
import pt from '@/locales/pt.json';
// @ts-ignore
import ro from '@/locales/ro.json';
// @ts-ignore
import ru from '@/locales/ru.json';
// @ts-ignore
import sk from '@/locales/sk.json';
// @ts-ignore
import sl from '@/locales/sl.json';
// @ts-ignore
import sv from '@/locales/sv.json';
// @ts-ignore
import tr from '@/locales/tr.json';
// @ts-ignore
import zh from '@/locales/zh.json';

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(StripeJS, { stripePublicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY });
Vue.use(Va, 'en');
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ComplyAPI);
Vue.use(VueDateFns);

let locale = Cookie.get('__ms.locale');

if (!locale) {
  // @ts-ignore
  const browserLanguage = navigator.language || navigator.userLanguage;
  locale = browserLanguage.split('-')[0];
}

const i18n = new VueI18n({
  fallbackLocale: 'de',
  locale,
  messages: {
    bg,
    cs,
    da,
    de,
    el,
    en,
    es,
    et,
    fi,
    fr,
    ga,
    he,
    hr,
    hu,
    it,
    ja,
    lt,
    lv,
    mt,
    nl,
    pl,
    pt,
    ro,
    ru,
    sk,
    sl,
    sv,
    tr,
    zh,
  },
});

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
